import React, { useEffect, useState } from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import EventsScreen from './events';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';
import Alcoholic from './alcoholic';
import Drinks from './drinks';
import LunchSpecial from './lunchspecial';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);
    const [dataDish, setDataDish] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [desserts, setdesserts] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showLunchSpecial, setShowLunchSpecial] = useState(false);
    const [Beverages, setBeverages] = useState(false);
    const [cocina, setcolombiana] = useState(false);
    const [pescadomarico, setpescadomarico] = useState(false);
    const [fuertes, setfuertes] = useState(false);
    const [antojitos, setantojitos] = useState(false);
    const [desayuno, setdesayuno] = useState(false);
    const [picada, setpicada] = useState(false);
    const [entrada, setentrada] = useState(false);
    const [coffe, setcoffe] = useState(false);
    const [cocktail, setcocktail] = useState(false);
    const [pastas, setpastas] = useState(false);
    const [drinks, setdrinks] = useState(false);
    
   

    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };


         const {
           goHomeInit
         } = useSelector((state) => state.initLoad);
        
    
        
    

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 906) {
                setdesserts(item);
            }

            if (item.id === 897) {
                setcolombiana(item);
            }
            if (item.id === 900) {
                setpescadomarico(item);
            }

            if (item.id === 898) {
                setfuertes(item);
            }

            if (item.id === 895) {
                setantojitos(item);
            }

            if (item.id === 894) {
                setdesayuno(item);
            }

            if (item.id === 896) {
                setpicada(item);
            }

            if (item.id === 905) {
                setentrada(item);
            }
             if (item.id === 907) {
                setcoffe(item);
             }
            
            if (item.id === 902) {
                setcocktail(item);
            }
            if (item.id === 899) {
                setpastas(item);
            }
            if (item.id === 901) {
                setpastas(item);
            }

            if (item.id === 901) {
                setdrinks(item);
            }



        });
    }, [menus]);


    const GoBeverages = () => {
        setShowListProduct(true);
        setdishs(Beverages);
    }


    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
          
          
           setShowLunchSpecial(false)
          
            setshowCategories(false)
            setShowDetailProduct(false)
            setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)

            getInitData()
        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);


      useEffect(() => {
     
                setShowListProduct(false);
            setShowSpecials(false)
          
           
           setShowLunchSpecial(false)
          
            setshowCategories(false)
          setShowDetailProduct(false)
           setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)
         }, [goHomeInit]);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

        
    

    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={() => {
                setShowListProduct(true)
                setdishs(Beverages)
        }} showBack={false} showCocktails={ GoBeverages} showEvents={ setShowEvents} showImageTop={true} setShowSpecials={setShowSpecials}>
                <div>
                    

                    <div style={{ width: '100%', position: 'relative', zIndex: 900, marginTop: -20, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 300,
                            height: 120,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 30,
                                
                            
                            
                            
                        }}
                        src={require('./assets/Bienvenido.png')}
                        />
{/* 
                        <div
                            onClick={() => {
                              setShowLunchSpecial(true);
                            }}
                            style={{
                             
                            width: 220,
                            height: 60,
                            justifyContent: 'center',
                            objectFit: 'contain',
                           
                            zIndex: 100,
                            alignSelf: 'center',
                            position: 'absolute',
                            right: -20,
                                top: 40,
                            zIndex: 2222

                            
                        }}>
                            <img
                            
                        style={{
                            width: 220,
                            height: 60,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            
                        }}
                        src={require('./assets/boton-lunch-special.png')}
                        />
                        </div> */}
                        
                       
                    </div>
                    
                    <div style={{
                     display: 'flex', width: '100%',
                        position: 'relative', zIndex: 100, paddingInline: 60,
                        boxSizing: 'border-box',
                        gap: 10,
                        marginTop: 20,
                       
                    }}>
                       
                        
                        <div style={{ width: '40%', marginTop: 10}}>
                            <img
                           
                            src={require('./assets/BANNERVERTICAL.png')}
                            loop autoPlay={true} muted 
                            style={{
                               
                                width: '100%',
                                height: 405,
                                objectFit: 'contain',
                                borderRadius: 14,
                                alignSelf: 'self-start',
                               
                            }}
                            />
                            
                           

                    </div>

                    <div style={{ width: '60%' }} >
                          
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                columnGap: 10,
                                height: 430,
                                overflowY: 'auto',
                                paddingRight: 0,
                                boxSizing: 'border-box',
                                marginTop: 5,
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 53,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require('./assets/categorias/1.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                        opacity: 1,
                                    
                                }}
                                onClick={() => {
                                    setShowListProduct(true);
                                    setdishs(cocina);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 53,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require('./assets/categorias/2.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                    setShowListProduct(true);
                                    setdishs(pescadomarico);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 53,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require('./assets/categorias/3.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                   setShowListProduct(true);
                                    setdishs(fuertes);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 53,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require('./assets/categorias/4.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                    setShowListProduct(true);
                                    setdishs(antojitos);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 53,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require('./assets/categorias/5.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                    setShowListProduct(true);
                                    setdishs(desayuno);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 53,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require('./assets/categorias/6.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                   setShowListProduct(true);
                                    setdishs(picada);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 53,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require('./assets/categorias/7.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                    setShowListProduct(true);
                                    setdishs(entrada);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 53,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require('./assets/categorias/8.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                    setShowListProduct(true);
                                    setdishs(coffe);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 53,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require('./assets/categorias/9.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                    setShowListProduct(true);
                                    setdishs(cocktail);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 53,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require('./assets/categorias/10.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                    setShowListProduct(true);
                                    setdishs(pastas);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 53,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require('./assets/categorias/11.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                    setShowListProduct(true);
                                    setdishs(drinks);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 53,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require('./assets/categorias/12.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                    setShowListProduct(true);
                                    setdishs(desserts);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                            </div>
                        </div>
                    </div>

                    
                </div>
               
            </div>

            <div
                    onClick={() => {
                       // setShowListProduct(true)
                        //setdishs(desserts)
                        //  setShowDetailProduct(true)
                 //   setDataDish({ dish: tomahawk, alldish: steak, currentDish: tomahawk })
               }}
                style={{
                    width: '100%',
                    alignItems: 'center',
                    paddingInline: 50,
                
                    boxSizing: 'border-box',
                   
                    }}>
                    <img
                        loop autoPlay={true} muted 
                        onContextMenu={(e) => e.preventDefault()}
                        //src={require('./assets/bannerinferior.png')}
                        src={require('./assets/bannerh.png')}
                    style={{
                        width: '95%',
                        height: 258,
                        objectFit: 'contain',
                        borderRadius: 15,
                        marginTop: -12,
                         pointerEvents: 'none',
                       
                        
                        
                    }}
                    />
                {/* <img
                    src={require('./assets/banner.png')}
                    style={{
                        width: '100%',
                        height: 174,
                        objectFit: 'contain',
                        borderRadius: 15,
                        marginTop: -10,
                        marginLeft: 5
                        
                    }}
                    /> */}
                  
            </div>

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}

                {showLunchSpecial && <LunchSpecial setShowHappy={setShowLunchSpecial} />}
                
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showDrinks && <Drinks setShowHappy={setShowDrinks} />}  
                 {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={()=>setShowDetailProduct(false)}
                    setShowDetailProduct={setShowDetailProduct}
                />}
                

            </LayoutContent>
            </div>
    );
}

export default Index;